import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { splitNumber } from "../../../utils/utility";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Sector,
} from "recharts";
import map from "lodash/map";
import reduce from "lodash/map";

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div
        className="recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15"
        style={{ background: "#000", border: "solid 1px #000", color: "#FFF" }}
      >
        <p className="recharts-tooltip-label no-margin" />
        <ul className="recharts-tooltip-item-list no-padding no-margin">
          <li
            className="recharts-tooltip-item"
            style={{
              display: "inline",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "auto",
                height: "25px",
                display: "block",
                overflow: "overlap",
                whiteSpace: "nowrap",
                textOverflow: "unset",
              }}
            >
              <div className="recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5">
                {payload[0].payload.key +
                  " : " +
                  (
                    parseFloat(payload[0].payload.value) /
                    parseFloat(payload[0].payload.total)
                  ).toLocaleString(undefined, {
                    style: "percent",
                    minimumFractionDigits: 2,
                  })}
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }

  return null;
};

class PieChartTable extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
    };
  }
  render() {
    const {
      dataKey,
      data,
      title,
      tableTitle,
      showUniqVisitsTitle,
      inLine,
      footer
    } = this.props;
    let sum = 0;
    map(data, d => {
      sum += d.value;
    });
    const processData = [];
    map(data, d => {
      processData.push({
        key: d.key ? d.key : d.name,
        value: d.value,
        total: sum,
      });
    });
    const COLORS = [
      "#216E69",
      "#32A59D",
      "#56CBC4",
      "#99DFDD",
      "#BBEAE7",
      "#BAE6FE",
      "#FFE0CA",
      "#F3D6D4",
    ];

    const style = inLine ? {
      box: {
        display: 'flex',
      },
      pieWidth: '50%',
      table: {
        width: '50%'
      }
    } : {
      box: {},
      pieWidth: '100%',
      table: {}
    };
    if (!processData || processData.length === 0) {
      return (
        <div>
          <div>
            {title && (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "24px",
                  padding: "20px 20px 0",
                }}
              >{title}</div>
            )}
          </div>
          <div style={{ width: '100%', minHeight: '280px', textAlign: 'center', paddingTop: '100px', color: "#CDCDCD" }}>
            <div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div>
          {title && (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "24px",
                padding: "20px 20px 0",
              }}
            >
              {title}
            </div>
          )}
        </div>
        <div style={{ width: "100%", fontSize: "16px", ...style.box }}>
          <ResponsiveContainer
            width={style.pieWidth}
            height="100%"
            minWidth="400px"
            minHeight="300px"
          >  
            <PieChart>
              <Pie
                dataKey={dataKey}
                data={processData}
                onMouseEnter={(data, index) => {
                  this.setState({ activeIndex: index });
                }}
                onMouseLeave={() => {
                  this.setState({ activeIndex: -1 });
                }}
              >
                {processData.map((entry, idx) => (
                  <Cell
                    key={"segment-graphic" + idx + "-cell-" + dataKey}
                    fill={COLORS[idx % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
          <div className={inLine ? 'mt-20' : 'mt-20 mb-20'} style={style.table}>
            {showUniqVisitsTitle ? (
              <div
                style={{
                  padding: "10px",
                  margin: "-20px 20px 10px",
                  background: "#F5F5F5",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>{tableTitle}</div>
                <div>Unique Visits</div>
              </div>
            ) : (
              <div
                style={{
                  padding: "10px",
                  margin: "-20px 20px 10px",
                  background: "#F5F5F5",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {tableTitle}
              </div>
            )}
            {processData.map((entry, idx) => {
              const pct = (
                parseFloat(entry.value) / parseFloat(entry.total)
              ).toLocaleString(undefined, {
                style: "percent",
                minimumFractionDigits: 2,
              });
              return (
                <div
                  key={"container-pie-" + idx}
                  style={{
                    display: "flex",
                    padding: showUniqVisitsTitle ? "10px" : "10px 0",
                    margin: "0px 20px",
                    borderBottom: "solid 1px #EEEFF2 ",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <span
                      style={{
                        width: "18px",
                        height: "18px",
                        display: "inline-block",
                        marginRight: "10px",
                        background: COLORS[idx % COLORS.length],
                      }}
                    >
                      &nbsp;
                    </span>
                    {entry.key ? entry.key : entry.name}
                  </div>
                  <div style={{ width: "50%", textAlign: "right" }}>{pct}</div>
                </div>
              );
            })}
            {footer}
          </div>
        </div>
      </div>
    );
  }
}

export default PieChartTable;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/PieChartTable.js